import React from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function CategoriesListing(props) {
    // props
    const { categoryItem, selectedCategories, handleCategorySelect, parentCategory } = props

    // variables
    let multiLevelCategories = null

    // if the category has sub items
    if (categoryItem?.sub_categories?.length) {
        multiLevelCategories = (
            // multilevel data
            <div className={`multilevel-container`}>
                {
                    categoryItem?.sub_categories?.length ? categoryItem?.sub_categories.map((item, index) => (
                        <CategoriesListing
                            key={item.category_id + index}
                            categoryItem={item}
                            parentCategory={categoryItem.category_name}
                            selectedCategories={selectedCategories}
                            handleCategorySelect={(ev, cat) => handleCategorySelect(ev, cat)}
                        />
                    )) : null
                }
            </div>
        )
    }


    return (
        // cat item
        <div className="cat-item">
            <div className="ci-inner">
                {/* check */}
                <label className="st-checkbox st-checkbox-primary d-flex align-items-center cursor-pointer">
                    <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                        defaultChecked={(selectedCategories.find(el => el.category_id === categoryItem.category_id)) ? true : false}
                        onChange={ev => handleCategorySelect(ev, {
                            category_id: categoryItem.category_id,
                            category_name: categoryItem.category_name,
                            parent_name: parentCategory ?? '',
                            is_default: selectedCategories?.length ? false : true
                        })}
                    />
                    <span className="text st-text-color st-fw-600 media-body pe-2">
                        {categoryItem.category_name}
                    </span>
                    <span className="box d-flex align-items-center justify-content-center border" style={{ height: 20, width: 20 }}>
                        <FeatherIcon
                            icon="check"
                            size="14"
                            className="icon" />
                    </span>
                </label>

                {/* multilevel category */}
                {multiLevelCategories}
            </div>
        </div >
    )
}
